import React from "react";

const dotStyle = {
  width: "20px",
  height: "20px",
  backgroundColor: "white",
  borderRadius: "50%", // Macht den Punkt rund
  animation: "pulse 1.5s infinite", // Animation, die endlos wiederholt wird
};

const keyframes = `
@keyframes pulse {
    0%, 100% {
        opacity: 0.3;
    }
    50% {
        opacity: 1;
    }
}
`;

const Spinner = () => (
  <>
    <style>{keyframes}</style>
    <div style={dotStyle}></div>
  </>
);

export default Spinner;
